export const slugifyTitle = (title = '') =>
    title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')

export const getBrochureSlug = (brochure) => brochure?.slug || slugifyTitle(brochure?.title)
